import Config from "config";

import UserService from "Services/user";
import { getCookie, setCookie } from "Services/cookie";
import { init, isInited } from "Services/googleTagManager";

const MANAGER_COOKIE_KEY = "is_manager";

export const EVENT = {
  NAME: {
    VIRTUAL_PAGE_VIEW: "virtualPageView",
    FULL_STORY_TURN_ON: "fullStoryTurnOn",
    UA_EVENT: "UAevent",
  },
  CATEGORY: {
    REGISTRATION: "registration",
    LOGIN: "login",
    SITES: "sites",
    DIRECT_LINKS: "direct-links",
    ZONES: "zones",
    GET_TAG: "tags",
    PROFILE: "profile",
    RATES: "cpm-rates",
    STATISTICS: "statistics",
    ADV_STATISTICS: "adv-statistics",
    MESSAGES: "messages",
    SUBSCRIPTIONS: "subscriptions",
    INTEGRATIONS: "integrations",
    PIXELS: "pixels",
    INVOICES: "invoices",
    BILLING: "billing",
    WELCOME: "welcome",
    RSS_LIST: "rss-list",
    MONETIZATION_REQUEST: "monetization-requests",
  },
  ACTION: {
    PUB_REG_FIRST_LOGIN: "pub-reg-first-login",
    PUB_REG_FORM_STEP_ONE: "pub-reg-form-1-step",
    PUB_LOGIN_SUCCESS: "pub-login-success",
    PUB_LOGIN_FAILED: "pub-login-fail",
    PUB_ADD_SITE_SUCCESS: "pub-add-site-success",
    PUB_VERIFY_SITE_SUCCESS: "pub-verify-site-success",
    PUB_ZONE_ADDED: "pub-zone-added",
    PUB_LOGIN_PAGE_SUCCESSFULLY_LOADED: "pub-login-page-successfully-loaded",
  },
};

function dataLayerPush(data) {
  const isManager =
    UserService.isReadOnly() || getCookie(MANAGER_COOKIE_KEY) !== undefined;
  if (isManager) {
    return;
  }

  if (isInited()) {
    window?.dataLayer?.push(data);
  } else {
    init().then(() => {
      window?.dataLayer?.push(data);
    });
  }
}

function getGtmEventCategory(category) {
  return `${Config.role}-${category}`;
}

class Analytics {
  getGoogleAnalyticsClientId = () => {
    const rawCookie = getCookie("_ga");

    if (rawCookie) {
      return rawCookie.substring(6);
    }

    return null;
  };

  getUserID(id) {
    const userType = Config.role.substr(0, 3);
    return `${Config.partnerAlias}-${userType}-${id}`;
  }

  trackUserId(id) {
    if (!id) {
      return;
    }

    const userType = Config.role.substr(0, 3);
    const userID = `${Config.partnerAlias}-${userType}-${id}`;
    dataLayerPush({ userID });
  }

  trackPubType(pubType) {
    if (!pubType) {
      return;
    }

    dataLayerPush({ pub_type: pubType });
  }

  trackPageView(newVirtualPagePath = undefined) {
    const virtualPagePath = newVirtualPagePath || window.location.hash;
    dataLayerPush({
      event: EVENT.NAME.VIRTUAL_PAGE_VIEW,
      virtualPagePath,
    });
  }

  trackPageEventCategory(category) {
    dataLayerPush({ pageEventCategory: getGtmEventCategory(category) });
  }

  trackEvent(
    eventName,
    category,
    action,
    label = undefined,
    value = undefined
  ) {
    dataLayerPush({
      event: eventName,
      eventCategory: getGtmEventCategory(category),
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    });
  }

  trackFullStory() {
    dataLayerPush({
      event: EVENT.NAME.FULL_STORY_TURN_ON,
    });
  }

  updateManagerCookie() {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    setCookie(MANAGER_COOKIE_KEY, true, "/", date.toUTCString());
  }
}

const analyticsInstance = new Analytics();

export default analyticsInstance;